import React from "react";
import { motion } from "framer-motion";
import statsData from "../data/statsData";

const hoverCard = {
    rest: { y: 0, scale: 1, boxShadow: "0 0 0 rgba(0,0,0,0)" },
    hover: { y: -4, scale: 1.02, boxShadow: "0 14px 30px rgba(2, 6, 23, 0.10)", transition: { type: "spring", stiffness: 300, damping: 20 } },
    tap: { scale: 0.99 },
};

export default function StatsSection() {
    return (
        <section className="relative py-20">
            <div className="absolute inset-0 bg-gradient-to-b from-blue-50 to-white" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Proof by Numbers</h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">Reliable, fast, and human — at every step.</p>
                </div>

                <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-6" initial="hidden" whileInView="show" viewport={{ once: true }}>
                    {statsData.map((stat, index) => (
                        <motion.div
                            key={index}
                            initial="rest"
                            whileHover="hover"
                            whileTap="tap"
                            variants={hoverCard}
                            className="relative overflow-hidden rounded-2xl bg-white/70 backdrop-blur ring-1 ring-gray-200 p-6 text-center shadow-sm"
                        >
                            <div className="absolute inset-0 -z-10 bg-gradient-to-br from-blue-100/40 via-transparent to-cyan-100/30 opacity-60" />
                            <div className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2 tracking-tight">{stat.number}</div>
                            <div className="text-gray-600 font-medium">{stat.label}</div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}